import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';

export interface AiReceptionistCallTranscriptResponse {
  transcription_srt: string;
}

interface GetCompanyAiReceptionistCallTranscriptPayload {
  company_id: string;
  call_id: string;
}

export async function getCompanyAiReceptionistCallTranscript(
  payload: GetCompanyAiReceptionistCallTranscriptPayload,
  auth: Authentication,
): Promise<AiReceptionistCallTranscriptResponse> {
  try {
    if (!payload.company_id || !payload.call_id) {
      throw new GetCompanyAiReceptionistCallTranscriptFailure('company_id et call_id sont requis');
    }

    const response = await HttpClient.post('/company/ai-receptionist/calls/transcript', payload, auth.token);

    return response.data as AiReceptionistCallTranscriptResponse;
  } catch (e) {
    console.error('getCompanyAiReceptionistCallTranscript error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyAiReceptionistCallTranscriptFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyAiReceptionistCallTranscriptFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyAiReceptionistCallTranscriptFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
